<script setup lang="ts">

</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_342_61599)">
      <path
        d="M7.5753 7.49984C7.77122 6.9429 8.15792 6.47326 8.66693 6.17412C9.17593
        5.87497 9.77438 5.76562 10.3563 5.86543C10.9382 5.96525 11.466 6.26778
        11.8462 6.71945C12.2264 7.17112 12.4345 7.74278 12.4336 8.33317C12.4336
        9.99984 9.93363 10.8332 9.93363 10.8332M10.0003 14.1665H10.0087M18.3337
        9.99984C18.3337 14.6022 14.6027 18.3332 10.0003 18.3332C5.39795 18.3332
        1.66699 14.6022 1.66699 9.99984C1.66699 5.39746 5.39795 1.6665 10.0003
        1.6665C14.6027 1.6665 18.3337 5.39746 18.3337 9.99984Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_342_61599">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss">

</style>